function r() {
  return [];
}
var t = r;
export {
  t as default
};
//# sourceMappingURL=stubArray.js.map
